import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=64c17e15&scoped=true&"
import script from "./Header.vue?vue&type=script&setup=true&lang=ts&"
export * from "./Header.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c17e15",
  null
  
)

export default component.exports